import { render, staticRenderFns } from "./tianBaoC.vue?vue&type=template&id=412d23e1&scoped=true&"
import script from "./tianBaoC.vue?vue&type=script&lang=js&"
export * from "./tianBaoC.vue?vue&type=script&lang=js&"
import style0 from "./tianBaoC.vue?vue&type=style&index=0&id=412d23e1&prod&scoped=true&lang=css&"
import style1 from "./tianBaoC.vue?vue&type=style&index=1&id=412d23e1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412d23e1",
  null
  
)

export default component.exports